import { render, staticRenderFns } from "./ProductsTableAdmin.vue?vue&type=template&id=b55dcd76&scoped=true"
import script from "./ProductsTableAdmin.vue?vue&type=script&lang=js"
export * from "./ProductsTableAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55dcd76",
  null
  
)

export default component.exports